// extracted by mini-css-extract-plugin
export var discard = "_3t-3";
export var muiTooltipTooltip = "_3t-5";
export var notificationBar = "_3t-2";
export var saveButtonHoverSlotWrapper = "_3t-4";
export var show = "_3t-1";
export var spacer = "_3t-0";